<template>
    <div>
        <div class="row">
            <div class="col-lg col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Income')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="reports.total.value" />
                                </span>
                                <percent :value="reports.total.percentage" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Average Bill')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="reports.total.average" />
                                </span>
                                <percent :value="reports.total.percentageAverage" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Earned')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="reports.total.leftover" />
                                </span>
                                <percent :value="reports.total.percentage" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Payed out')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="reports.total.revenue" />
                                </span>
                                <percent :value="reports.total.percentage" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg col-md-6 col-sm-12" v-for="(byMethodReport, index) in byMethod" :key="index">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{ $t(byMethodReport._id) }}</h6>
                                <span class="h4 mb-0">
                                    <money :value="byMethodReport.count" />
                                </span>
                                <percent :value="byMethodReport.percentage" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="balanceReports.currentDebt">
            <div class="col-lg col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Debt')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="balanceReports.currentDebt"></money>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg col-md-6 col-sm-12" v-if="balanceReports.currentPrepaid">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Prepaid')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="balanceReports.currentPrepaid"></money>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="byMethod.length">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('By payment type')}}</h6>
                                <Doughnut :chartData="byMethod" scheme="HueCircle19"></Doughnut>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="periodical.length">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{ $t('Last 12 month') }}</h6>
                                <line-chart :chartData="periodical" scheme="HueCircle19"></line-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Percent from '@/components/Percent.vue';
import DateFilter from '@/components/DateFilter.vue';
import TeamFilter from '@/components/TeamFilter.vue';
import Doughnut from '@/components/Charts/Doughnut.vue'
import LineChart from '@/components/Charts/LineChart.vue'
import Money from '@/components/Money.vue';
import { mapActions, mapGetters } from 'vuex';
import BranchesFilter from "@/components/BranchesFilter";

export default {
    props: { branchesId: Array, user: Array, dates: Object },
    components: {
        BranchesFilter,
        Percent,
        Doughnut,
        LineChart,
        DateFilter,
        TeamFilter,
        Money
    },
    data() {
        return {
            reports: {
                total: {
                    average: 0,
                    value: 0
                }
            },
            byMethod: [],
            byUser: [],
            balanceReports: {},
            periodical: [],
        }
    },
    computed: {
        ...mapGetters('my-team', { 'getMember': 'get' })
    },
    watch: {
        user(newUser) {
            this.fetchSalesReport();
        },

        branchesId(newValue) {
            this.fetchSalesReport();
            this.fetchPaymentReport()
        },

        dates(dates) {
            this.fetchPaymentReport();
            this.fetchSalesReport();
        },
    },
    created() {
        this.fetchPaymentReport();
        this.fetchSalesReport();
    },
    methods: {
        ...mapActions('sales-reports', ['find']),
        ...mapActions('payment-reports', { findPaymentReports: 'find' }),
        ...mapActions('balance-reports', { findBalanceReports: 'find' }),
        ...mapActions('specialty', { getSpecialty: 'get' }),

        fetchPaymentReport() {
            this.byMethod = [];
            let query = {};
            if (this.dates.start) {
                query.date = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                }
            }
            this.findPaymentReports({ query }).then(data => {
                this.byMethod = data[0].map(el => ({ _id: this.$t(el._id), count: el.amount }));
            });
        },

        fetchSalesReport() {
            let query = {};
            if (this.dates.start) {
                query.date = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                }
            }

            if (this.branchesId.length > 0)
                query.branchesId = this.branchesId;

            if (this.user.length > 0)
                query.user = { $in: this.user };

            this.reports = {
                total: {
                    value: 0,
                    average: 0
                }
            };
            this.periodical = [];

            this.find({ query }).then(data => {
                data = data[0];
                if (data.total) {
                    this.$set(this.reports, 'total', data.total);
                }
                /* Chart by date  */
                if (data.byDate) {
                    data.byDate.forEach(element => {
                        let date = this.$moment().set(
                            {
                                year: element._id.year,
                                month: element._id.month - 1,
                                date: element._id.dayOfMonth
                            }
                        );

                        this.periodical.push({
                            _id: date.format('MMMM Y'),
                            count: element.value
                        })

                    });
                }
            });

            this.findBalanceReports({ query }).then(data => {
                this.balanceReports = data[0];
            })
        }
    }
}
</script>
